import { Grid, InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { MuiTextFieldWithFocus } from '../../../../config/MaterialUIConstants';
import VehicleMakeSelection from '../SavedServicesAddModal/VehicleMakeSelection';

const SearchAndFilters = ({ searchTerm, onSearchChange, vehicleMake, selectedVehicles, onVehicleChange }) => {
    return (
        <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={8}>
                <TextField
                    fullWidth
                    placeholder="Search service or reference..."
                    value={searchTerm}
                    onChange={onSearchChange}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path
                                        d="M14.0762 14.1002L16.6429 16.6668M15.832 9.5835C15.832 11.2411 15.1736 12.8308 14.0014 14.0029C12.8293 15.175 11.2396 15.8335 9.58203 15.8335C7.92443 15.8335 6.33472 15.175 5.16261 14.0029C3.99051 12.8308 3.33203 11.2411 3.33203 9.5835C3.33203 7.92589 3.99051 6.33618 5.16261 5.16408C6.33472 3.99198 7.92443 3.3335 9.58203 3.3335C11.2396 3.3335 12.8293 3.99198 14.0014 5.16408C15.1736 6.33618 15.832 7.92589 15.832 9.5835Z"
                                        stroke="#6E6E6E"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </InputAdornment>
                        ),
                    }}
                    sx={MuiTextFieldWithFocus}
                />
            </Grid>
            <Grid item xs={4}>
                <VehicleMakeSelection
                    showTypography={false}
                    vehicleMake={vehicleMake}
                    selectedMakes={selectedVehicles}
                    setFormSelectedMakes={onVehicleChange}
                />
            </Grid>
        </Grid>
    );
};

export default SearchAndFilters;
